import { useState } from "react";
import { axiosApiInstance } from "../../axios";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function ReceiptsScreenViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [inProgress, setInProgress] = useState(false);
  const [receipt, setReceipt] = useState(null);

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          title="Error"
          subtitle={subtitle}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const onUploadReceipt = async (file) => {
    try {
      setInProgress(true);

      const fd = new FormData();
      fd.append("image", file);
      fd.append("user_id", String(Number(localStorage.getItem("id") || 0)));
      fd.append("user_name", localStorage.getItem("name") || "");

      const res = await axiosApiInstance.post("receipts/extract-total", fd, {
        // DO NOT set Content-Type; let axios set multipart boundary
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      });

      setReceipt(res.data);
      if (!res.data.success) {
        showErrorModal("We could not scan your receipt");
      }
      return { success: true, data: res.data };
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) logout();

      const msg =
        e?.response?.data?.message ||
        e?.message ||
        "We could not complete the action.";

      showErrorModal(msg);
      return {
        success: false,
        errorStatus: status,
        data: e?.response?.data ?? { message: msg },
      };
    } finally {
      setInProgress(false);
    }
  };

  return {
    onUploadReceipt,
    emptyModal,
    setEmptyModelOpen,
    receipt,
    inProgress,
  };
}
